// OWNER: Agent C. Stale prices are surfaced, never silently omitted —
// a dismissible banner listing every affected holding.
import { useState } from "react";
import { Banner } from "@cloudflare/kumo/components/banner";
import { WarningIcon } from "@phosphor-icons/react";

export function StalePriceBanner({ warnings }: { warnings: string[] }) {
  // Keyed on content so a newly-appeared warning reopens even if a
  // previous, different set was dismissed.
  const key = warnings.join("|");
  const [dismissedKey, setDismissedKey] = useState<string | null>(null);

  if (warnings.length === 0 || dismissedKey === key) return null;

  return (
    <Banner
      icon={<WarningIcon weight="fill" />}
      variant="alert"
      title={warnings.length === 1 ? "One price is out of date" : `${warnings.length} prices are out of date`}
      description={warnings.join(" · ")}
      action={
        <button
          type="button"
          onClick={() => setDismissedKey(key)}
          className="text-sm text-kumo-subtle underline underline-offset-2"
          aria-label="Dismiss stale price warning"
        >
          Dismiss
        </button>
      }
    />
  );
}
